import React, { useEffect, useState, useCallback } from 'react'
import { useDropzone } from 'react-dropzone'
import File from 'components/File'

const Files = ({ orderId, FileComponent, allowDelete = true }) => {
  const [files, setFiles] = useState([])

  const Component = FileComponent || File

  useEffect(() => {
    fetch(`/rest/v1/order/${orderId}/files`)
      .then((response) => response.json())
      .then(({ data }) => setFiles(data))
      .catch((err) => {
        window.alert(err)
      })
  }, [orderId])

  const onDelete = useCallback((id) => {
    fetch(`/rest/v1/order/${orderId}/files/${id}`, { method: 'DELETE' }) 
      .then((response) => response.json())
      .then(({ data: { uid } }) => setFiles((files) => files.filter((file) => file.uid !== uid )))
      .catch((err) => {
        window.alert(err)
      })
  }, [orderId])

  const onDrop = useCallback((acceptedFiles) => {

    acceptedFiles.map((file) => {
      const id = Math.random().toString(36).substr(2, 9)

      setFiles((files) => ([...files, { title: file.path, filesize: file.size, id }]))

      const body = new FormData()
      body.append('id', id);
      body.append('file', file);

      fetch(`/rest/v1/order/${orderId}/files`, { method: 'POST', body })
        .then((response) => response.json())
        .then(({ success, data, meta }) => {
          if (!success) {
            setFiles((files) => files.filter(({ id }) => id === meta.id ))
            console.error(success, data, meta)
            return
          }

          setFiles((files) => files.map((file) => file.id === meta.id ? data : file))
        })
        .catch((err) => window.alert(err))
    })
  }, [orderId, files])

  const { acceptedFiles, getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop })

  return (
    <div className="w-full h-full max-h-full overflow-scroll shadow-inner cursor-pointer" {...getRootProps()}>
        <input {...getInputProps()} />
        <div className="max-h-full overflow-scroll" onClick={(e) => e.stopPropagation()}>
          { files.map((file) => (
              <Component
                key={file.title}
                id={file.uid}
                title={file.title}
                fileSize={file.filesize}
                onDelete={allowDelete && !!file.url && (() => onDelete(file.uid))}
                uploading={!file.url}
                url={file.url}
              />
          )) }
        </div>
        <div className="w-full text-center px-2 py-4 text-gray-500">
          {
            isDragActive ?
              <p>Drop the files here ...</p> :
              <p>Drag and drop files here, or <span className="text-primary font-medium">click</span> to select files</p>
          }
        </div>
    </div>
  )
}

export default Files
